export default {
	common: {
		retry: 'Retry',
		retry_access: 'Retry access',
		see_more: 'See more',
		system_default_device: 'System default',
		problem_occurred: 'A problem occurred while trying to connect to the video consultation. You will be redirected to the waiting room again.',
		insurance: 'Insurance'
	},
	datetime: {
		locale: 'en',
		datetime_format: 'MM-DD-YYYY · HH:mm',
	},
	config: {
		microphone: 'Microphone',
		external_headphones: 'External headphones',
		camera: 'Camera',
		how_to_permissions: 'How to activate permissions?',
		mic_and_vid_not_granted: 'Your microphone and camera are turned off',
		permissions_text: 'For other participants to hear and see you, the browser you\'re using to join the video consultation will request <strong>access to your microphone and camera</strong>. <p>Finally, you must finish <strong>setting up system preferences</strong> to continue.</p>',
	},
	waiting_room: {
		next_videoconsultation: 'Upcoming video consultation',
		videoconsultation: 'Video consultation',
		title: 'You are about to join a video consultation',
		info: 'Information',
		access: 'Join',
		professional_not_available: {
			title: 'WE’RE WAITING FOR THE PROFESSIONAL',
			message: 'Your doctor hasn’t connected yet. Sometimes minor delays occur. Thank you for your patience.',
		},
		professional_no_show: {
			title: 'THE PROFESSIONAL DID NOT SHOW UP',
			message: 'The professional has had an unexpected issue and it appears they won\'t be able to join the consultation. We apologize for the inconvenience and recommend that you schedule a new appointment.'
		},
		capabilities_ko: {
			title: 'CLIENT NOT SUPPORTED',
			message: 'Your browser or device is not compatible with the video consultation. Please update your browser or change your connection device.'
		},
	},
	participant_info: {
		professional: 'Professional',
		patient: 'Patient',
		subject: 'Reason',
		subject_long: 'Reason for the consultation',
		speciality: 'Specialty',
		datetime: 'Date and time',
		duration: 'Estimated duration',
		copy_link: 'Copy link',
	},
	tools: {
		chat: 'Private chat',
	},
	chat: {
		empty_title: 'Do you want to start a private chat?',
		empty_description:
			'Only participants in this video consultation will have access to the messages sent.',
		type: 'Write your message...',
	},
	hang_up: {
		title: 'End video consultation',
		finish: 'End',
		suspend: 'Put on hold',
		warning:
			'For this video consultation to be considered valid, it must last at least three minutes.',
		message: 'This access link is for single use only. If you <strong>end</strong> this video consultation, you will not be able to re-access it, even within the scheduled time.',
	},
	too_early: {
		title: 'VIDEO CONSULTATION ACCESS',
		vc_time: 'Video consultation time',
		waiting_time: 'Waiting time',
		message: 'Access is not yet available. Please try again shortly — your doctor may open the session early and allow entry before the scheduled time. <br/> (Time will display accordingly, e.g. "Monday 15:20")',
		professional_available: 'Your doctor is available. You can now join your video consultation.',
	},
	permissions: {
		title: 'Enable Camera & Microphone',
		content: 'To start your video consultation, we need access to your camera and microphone.',
		request_permissions: 'Allow Access',
	},
	vc: {
		finish_title: 'END OF THE VIDEO CONSULTATION',
		finish_content:
			'The video consultation has ended successfully. Thank you for using our platform!',
	},
	feedback: {
		title: 'HOW DO YOU RATE YOUR VIDEO CONSULTATION?',
		success_by_video: 'Successful via video',
		success_by_phone: 'Successful via phone',
		unsuccess: 'Not successful',
		reason: 'Please specify the reason:',
		patient_not_shown_up: 'Patient no-show',
		patient_could_not_connect: 'The patient could not connect',
		other: 'Other',
		fail_message: 'The feedback could not be sent. Please try again.',
		already_registered_message: 'This video consultation has already been rated. It cannot be rated again.',
	},
	meet_actions: {
		copy_link: 'Copy link',
		share_screen: 'Share screen',
		stop_share_screen: 'Stop sharing',
	},
	alerts: {
		copied_link: 'Video consultation access link copied.',
		participant_disabled_cam: 'has turned off the camera.',
		participant_disabled_mic: 'has turned off the microphone.',
		sharing_screen: 'You are sharing your screen',
		presentation: 'Presentation by',
	},
	errors: {
		title: 'Information about your video consultation',
		invalid_code:
			'Unable to access the video consultation. This may be because the link is invalid, does not exist, or it is not yet the scheduled time.',
		title_too_early: 'Waiting room',
		too_early: 'You\'re early! Please try again in a few minutes.',
		title_finished_meet: 'Video consultation not available',
		finished_meet: 'Your video consultation time has ended. This link has expired.',
		title_too_late: 'Video consultation ended',
		too_late: 'This video consultation has already ended.',
		refresh_meet_failed: 'There was an error loading the video consultation data. Please try again.',
		devices_in_use_title: 'Devices in use',
		devices_in_use_description: 'You can\'t access the video consultation because there\'s an access issue with your microphone and camera. Please check that another app isn\'t using them and grant permissions when prompted by your browser.',
		devices_not_found: 'Devices not found',
		devices_denied: 'Device permissions denied',
		devices_error: 'Error using microphone/camera'
	},
};
